import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

import { LoginDocuments } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { LoggerService } from 'src/app/core/services/logger.service';
import { UtilService } from 'src/app/core/services/util.service';
import { TranslationService } from 'src/app/i18n';

@Component({
    selector: 'app-login-audits-details',
    templateUrl: './login-audits-details.component.html',
    styles: [
        `
      .log-text {
        min-height: 238px !important;
      }
    `,
    ],
    standalone: false
})
export class LoginAuditsDetailsComponent implements OnInit {
  title = 'common.detail';
  fields = 'pages.loginAudits.fields.';
  legends = 'pages.loginAudits.legends.';

  loading;

  protected onDestroy$ = new Subject<void>();

  @Input() model: LoginDocuments = {};
  @Input() requestBody: string;

  @Output('closePage') output_closPage = new EventEmitter<boolean>();

  constructor(
    public translationService: TranslationService,
    private loggerService: LoggerService
  ) {}

  ngOnInit() {
    try {
      window.scroll(0, 0);
      this.convertLogTextToUnit8Array();
    } catch (error) {
      this.loggerService.logError(
        'app-login-audits-details',
        error,
        EventTypes.infrastructure
      );
    }
  }

  convertLogTextToUnit8Array() {
    // const firstTextArray: string[] = (this.model.logText as string).split(
    //   '"MessageBodies":["'
    // );
    // if (!firstTextArray?.length) return;
    // const secondTextArray: string[] = firstTextArray[1].split('"],');
    // const convertedText = UtilService.unicodeToChar(secondTextArray[0]);

    // // merge  before text and text and after text
    // this.model.logText = `${firstTextArray[0]}\n"MessageBodies":\n[" ${convertedText}"],\n${secondTextArray[1]}`;
  }

  onClose() {
    this.output_closPage.emit(true);
  }
}
